import { FC } from 'react'

type Props = {
  source: string
  children: JSX.Element[]
  className: string
}

const GenericDisclaimer: FC<Props> = ({ source, children, className }) => (
  <p data-pw="apply-disclaimer" className={className} style={{ fontSize: 12, marginTop: 15 }}>
    By applying, a {source} account will be created for you. <span>{children}</span> will apply.
  </p>
)

export default GenericDisclaimer
